import gql from "graphql-tag";
import graphqlClient from "@/http/graphql/cbs";

const ALARMSGS = `
	Alarmsgs(page: $page, limit: $limit, search: $search) 
    {
		data {
			id
			title
			desc
			tutorial
			is_received
			created_at
			type
			ref_type
			ref {
				id
				name
			}
		 
	  	}
		total
	}`;
const ALARMS_SETTING = `
Alarms(page: $page, limit: $limit, search: $search) {
    data {
      id
      name
      enable
      remining_times
	  form_data
	  object 
	  until_received
	  created_at
	}
	total
}`;
const CREATE_ALARM = `
	CreateAlarm(
		name: $name,
		remining_times: $remining_times,
		conditions: $conditions,
		properties: $properties,
		enable: $enable,
		until_received: $until_received,
		ref_model_name: $ref_model_name,
		apply_for: $apply_for,
		exclude: $exclude,
		repeat: $repeat
  	) {
		id
		name
		enable
		remining_times
		form_data
		object 
		until_received
		created_at
  	}
`;
const UPDATE_ALARM = `
	UpdateAlarm(
		id: $id,
		name: $name,
		remining_times: $remining_times,
		conditions: $conditions,
		properties: $properties,
		enable: $enable,
		until_received: $until_received,
		ref_model_name: $ref_model_name,
		apply_for: $apply_for,
		exclude: $exclude,
		repeat: $repeat
  	) {
		id
		name
		enable
		remining_times
		form_data
		object 
		until_received
		created_at
  	}
`;
const DELETE_ALARM = `
	DeleteAlarm(
		id: $id
  	) {
		id
		name
  	}
`;

const ALARM_OBJECT = `
AlarmObject {
    key
	value
	model
    properties {
		key
		value
		type
	}
	apply_scope {
		type
		key
		value
	  }
	exclude_scope {
		type
		key
		value
	}
}
`;

const ALARM_APPLY_OBJECT = `
	apply_object(limit: $limit, search: $search, model: $model) {
		id
		name
		type
	}
`;

const RECEIVED_ALARMSG = `ReceivedAlarmsg(id: $id)`;

const ALARMSG_ITEM = `
	Alarmsg(id: $id) {
		id
		title
		type
		desc
		tutorial
		is_received
		created_at
		ref_type
		ref {
			id
			name
		}
  	}
`;

export default {
	init() {},
	getAlarmsgs(payload) {
		const queryOptions = {
			query: gql`query Alarmsgs ($limit: Int!, $page: Int!, $search: String) {
					${ALARMSGS}
				}
			`,
			variables: {
				limit: payload.limit || -1,
				page: payload.page || 1,
				search: payload.search || ""
			}
		};
		return graphqlClient.query(queryOptions).then(response => {
			return {
				alarms: response.data.Alarmsgs.data,
				total: response.data.Alarmsgs.total
			};
		});
	},
	getAlarmObject() {
		const queryOptions = {
			query: gql`query AlarmObject {
					${ALARM_OBJECT}
				}
			`
		};
		return graphqlClient.query(queryOptions).then(response => {
			return {
				alarmObject: response.data.AlarmObject
			};
		});
	},
	getAlarmsSetting(payload) {
		const queryOptions = {
			query: gql`query AlarmsSetting ($limit: Int!, $page: Int!, $search: String) {
					${ALARMS_SETTING}
				}
			`,
			variables: {
				limit: payload.limit || -1,
				page: payload.page || 1,
				search: payload.search || ""
			}
		};
		return graphqlClient.query(queryOptions).then(response => {
			return {
				alarmsSetting: response.data.Alarms.data,
				total: response.data.Alarms.total
			};
		});
	},
	createAlarm(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation CreateAlarm (
					$name: String!,
					$remining_times: Int!,
					$conditions: String!,
					$properties: String!,
					$enable: Boolean,
					$until_received: Boolean,
					$ref_model_name: String,
					$exclude: String,
					$apply_for: String,
					$repeat: String
					) {
						${CREATE_ALARM}
					}
				`,
				variables: {
					name: payload.name,
					remining_times: payload.remining_times,
					conditions: payload.conditions,
					properties: payload.properties,
					enable: payload.enable,
					until_received: payload.until_received,
					ref_model_name: payload.ref_model_name,
					exclude: payload.exclude,
					apply_for: payload.apply_for,
					repeat: payload.repeat
				}
			})
			.then(response => response.data.CreateAlarm);
	},
	updateAlarm(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation UpdateAlarm (
					$id: Int!,
					$name: String!,
					$remining_times: Int!,
					$conditions: String!,
					$properties: String!,
					$enable: Boolean,
					$until_received: Boolean,
					$ref_model_name: String,
					$exclude: String,
					$apply_for: String,
					$repeat: String
					) {
						${UPDATE_ALARM}
					}
				`,
				variables: {
					id: payload.id,
					name: payload.name,
					remining_times: payload.remining_times,
					conditions: payload.conditions,
					properties: payload.properties,
					enable: payload.enable,
					until_received: payload.until_received,
					ref_model_name: payload.ref_model_name,
					exclude: payload.exclude,
					apply_for: payload.apply_for,
					repeat: payload.repeat
				}
			})
			.then(response => response.data.UpdateAlarm);
	},
	deleteAlarm(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation DeleteAlarm (
					$id: Int!
					) {
						${DELETE_ALARM}
					}
				`,
				variables: {
					id: payload.id
				}
			})
			.then(response => response.data.DeleteAlarm);
	},
	receivedAlarmsg(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ReceivedAlarmsg (
					$id: Int!
					) {
						${RECEIVED_ALARMSG}
					}
				`,
				variables: {
					id: payload.id
				}
			})
			.then(response => response.data.ReceivedAlarmsg);
	},
	getAlarmApplyObject(payload) {
		const queryOptions = {
			query: gql`query AlarmApplyObject ($limit: Int, $model: String!, $search: String) {
					${ALARM_APPLY_OBJECT}
				}
			`,
			variables: {
				limit: payload.limit || -1,
				model: payload.model || 1,
				search: payload.search || ""
			}
		};
		return graphqlClient.query(queryOptions).then(response => {
			return {
				objects: response.data.apply_object
			};
		});
	},
	getAlarmsgItem(id) {
		const queryOptions = {
			query: gql`query AlarmsgItem ($id: Int) {
					${ALARMSG_ITEM}
				}
			`,
			variables: {
				id: id
			}
		};
		return graphqlClient.query(queryOptions).then(response => {
			return response.data.Alarmsg;
		});
	}
};
